


export    const selectedCountryTemplate = (option, props) => {
  if (option) {
      return (
          <div className="flex">
              <div>+{option.dial_code}</div>
          </div>
      );
  }

  return (
      <span className=" text-white">
          {props.placeholder}
      </span>
  );
}

export const countryOptionTemplate = (option) => {
  return (
      <div className="text-white" >
          <span> +{option.dial_code} {option.name}</span>
      </div>
  )
}
